import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-177" data-mp="3kqw54mwtl6h6">
      <div className="mx-auto max-w-5xl" data-id="element-178" data-mp="3fz5mzurn5ef7">
        <h2 className="text-center font-display text-[1.75rem] font-black leading-tight tracking-tight text-ink sm:text-[2.4rem]" data-id="element-179" data-mp="3fxuly2pkykrs">
          Cosa dicono i docenti
        </h2>
        <p className="mt-3 text-center text-sm font-medium text-ink/70" data-id="element-180" data-mp="3700oupjzrn3k">
          4.9/5 · +2.000 docenti
        </p>

        <div className="mx-auto mt-10 grid max-w-4xl gap-5 sm:grid-cols-3" data-id="element-181" data-mp="31ybgxis2fpjp">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl bg-sand p-6" data-id="element-182" data-mp="2x2w4mv9pi1pe">
              <div className="flex gap-0.5" aria-label="5 stelle su 5" data-id="element-183" data-mp="v9yfb9f51r97">
                {Array.from({
              length: 5
            }).map((_, starIndex) => <StarIcon key={starIndex} className="h-3.5 w-3.5 fill-amber-500 text-amber-500" aria-hidden="true" data-id="element-184" data-mp="qav9vnv8xj0p" data-mpi={starIndex} />)}
              </div>
              <blockquote className="mt-4 flex-1 font-display text-sm italic leading-relaxed text-ink/85" data-id="element-185" data-mp="77s75y6t68za">
                &ldquo;{item.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6" data-id="element-186" data-mp="c8y0ny8am09v">
                <p className="text-xs font-bold text-ink" data-id="element-187" data-mp="zvwgctol946q">{item.name}</p>
                <p className="text-xs text-ink/50" data-id="element-188" data-mp="14vj3pvy4s0t9">{item.location}</p>
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-8 text-center text-[11px] text-ink/40" data-id="element-189" data-mp="q5lb93t64oy9">
          Testimonianze illustrative a scopo dimostrativo.
        </p>
      </div>
    </section>;
}